import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Container,
  Grid,
  styled,
} from "@mui/material";

interface Project {
  id: number;
  title: string;
  description: string;
  imageUrl: string;
}

// Styled components
const StyledCard = styled(Card)(({ theme }) => ({
  position: "relative",
  height: "100%",
  overflow: "hidden",
  "&:hover .overlay": {
    opacity: 1,
  },
  "&:hover .media": {
    transform: "scale(1.05)",
  },
}));

const CardOverlay = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  padding: theme.spacing(2),
  opacity: 0,
  transition: "opacity 0.3s ease-in-out",
}));

const StyledCardMedia = styled(CardMedia)({
  height: "100%",
  transition: "transform 0.3s ease-in-out",
});

const ProjectsGrid = () => {
    const projects: Project[] = [
        {
          id: 1,
          title: "Innovative Workstations",
          description: "Designed to inspire productivity and creativity.",
          imageUrl: "b-a.jpg",
        },
        {
          id: 2,
          title: "Collaborative Spaces",
          description: "Modern areas for teamwork and brainstorming sessions.",
          imageUrl: "team1.jpg",
        },
        {
          id: 3,
          title: "Relaxation Zones",
          description: "Comfortable spaces to recharge and stay motivated.",
          imageUrl: "team5.jpg",
        },
        {
          id: 4,
          title: "Executive Offices",
          description: "Stylish and private workspaces for focused leadership.",
          imageUrl: "Matt Image111.jpg",
        },
        {
          id: 5,
          title: "Creative Corners",
          description: "Bright and colorful areas to fuel innovative ideas.",
          imageUrl: "team5.jpg",
        },
      ];
      

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 4, textAlign: "center" }}>
        <Typography
        className="component"
          variant="h4"
          component="h1"
          sx={{ fontWeight: "bold", mb: 1, color: "#012f57" }}
        >
          Discover{" "}
          <span
            style={{
              background:
                "linear-gradient(-96deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 4%) 28%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 100%)",
              padding: "0px 2px",
              borderLeft: "2px solid rgba(253,150,16,1)",
            }}
          >
            Our Creative Workspace
          </span>
        </Typography>
        <Typography variant="body2" color="text.secondary" className="component">
          Explore our vibrant office gallery, designed to inspire creativity and
          innovation.
        </Typography>
      </Box>

      {/* Desktop Layout */}
      <Box
        sx={{
          display: { xs: "none", lg: "grid" },
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 2,
        }}
      >
        {/* First Column */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <StyledCard sx={{ height: 250 }} className="component">
            <StyledCardMedia
              className="media"
              image="b-a.jpg"
              title="Project 1"
              sx={{ height: "100%" }}
            />
            <CardOverlay className="overlay">
              <Typography variant="h6" color="white" gutterBottom>
              Innovative Workstations
              </Typography>
              <Typography variant="body2" color="white">
              Designed to inspire productivity and creativity.
              </Typography>
            </CardOverlay>
          </StyledCard>
          <StyledCard sx={{ height: 250 }} className="component">
            <StyledCardMedia
              className="media"
              image="team1.jpg"
              title="Explore More"
              sx={{ height: "100%" }}
            />
            <CardOverlay className="overlay">
              <Typography variant="h6" color="white" gutterBottom>
              Collaborative Spaces
              </Typography>
              <Typography variant="body2" color="white">
              Modern areas for teamwork and brainstorming sessions.
              </Typography>
            </CardOverlay>
          </StyledCard>
        </Box>

        {/* Middle Column */}
        <StyledCard sx={{ height: 520 }} className="component">
          <StyledCardMedia
            className="media"
            image="Matt Image111.jpg"
            title="Project 2"
            sx={{ height: "100%" }}
          />
          <CardOverlay className="overlay">
          <Typography variant="h6" color="white" gutterBottom>
          Executive Offices
</Typography>
<Typography variant="body2" color="white">
Stylish and private workspaces for focused leadership.
</Typography>
          </CardOverlay>
        </StyledCard>

        {/* Third Column */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <StyledCard sx={{ height: 250 }} className="component">
            <StyledCardMedia
              className="media"
              image="team7.jpg"
              title="Project 3"
              sx={{ height: "100%" }}
            />
            <CardOverlay className="overlay">
              <Typography variant="h6" color="white" gutterBottom>
              Creative Corners
              </Typography>
              <Typography variant="body2" color="white">
              Bright and colorful areas to fuel innovative ideas.
              </Typography>
            </CardOverlay>
          </StyledCard>
          <StyledCard sx={{ height: 250 }} className="component">
            <StyledCardMedia
              className="media"
              image="team5.jpg"
              title="Project 4"
              sx={{ height: "100%" }}
            />
            <CardOverlay className="overlay">
              <Typography variant="h6" color="white" gutterBottom>
              Relaxation Zones
              </Typography>
              <Typography variant="body2" color="white">
              Comfortable spaces to recharge and stay motivated.
              </Typography>
            </CardOverlay>
          </StyledCard>
        </Box>
      </Box>

      {/* Mobile Layout */}
      <Grid
        container
        spacing={2}
        sx={{
          display: { xs: "flex", lg: "none" },
        }}
      >
        {projects.map((project) => (
          <Grid item xs={12} sm={6} key={project.id}>
            <StyledCard className="component">
              <StyledCardMedia
                className="media"
                image={project.imageUrl}
                title={project.title}
                sx={{ height: 200 }}
              />
              <CardOverlay className="overlay">
                <Typography variant="h6" color="white" gutterBottom>
                  {project.title}
                </Typography>
                <Typography variant="body2" color="white">
                  {project.description}
                </Typography>
              </CardOverlay>
            </StyledCard>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ProjectsGrid;
